import React from "react";

const Mains = ({ type, meals }) => {
  return (
    <section className="mains">
      <h2 className="extras-heading">{type}</h2>
          <strong className="mains-strong"> to stay / to go</strong>
      {meals.map((meal, index) => (
        <article className="menu-item" key={index}>
          <h3 className="mains-name">{meal.name}</h3>
          
          <strong className="mains-strong">€{meal.price_1} - {meal.price_2}</strong>
          {/*<p className="mains-description">{meal.description}</p>*/}
        </article>
      ))}
    </section>
  );
};

export default Mains;